import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { ComplianceMonitorPage } from '@/features/compliance-monitor/compliance-monitor-page';

/** The km-restriction compliance monitor. Its report endpoint requires `compliance:read`. */
export const Route = createFileRoute('/_app/service-agreement/compliance')({
  staticData: { featureKey: 'service-agreement-compliance-monitor' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreement-compliance-monitor',
      permissions: ['compliance:read'],
    }),
  component: ComplianceMonitorPage,
});
